export default __webpack_public_path__ + "86c28ca4d667918085a3a827d92faeb6.svg";